<template>
    <div>
        <div class="row mb-3 mt-5">
            <ul class="nav nav-tabs px-3 tabs" role="tablist">
                <li class="nav-item">
                    <button
                        class="nav-link"
                        :class="{ active: currentTab === 'tab1', 'text-muted': currentTab !== 'tab1' }"
                        @click="currentTab = 'tab1'"
                    >
                        Modèles gratuits
                    </button>
                </li>

                <li class="nav-item">
                    <button
                        class="nav-link"
                        :class="{ active: currentTab === 'tab2', 'text-muted': currentTab !== 'tab2' }"
                        @click="currentTab = 'tab2'"
                        :disabled="true"
                    >
                        Modèles payants
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="18"
                            viewBox="0 0 18 18"
                            fill="none"
                            class="lock"
                        >
                            <path
                                d="M6 7.5V5.25C6 4.45435 6.31607 3.69129 6.87868 3.12868C7.44129 2.56607 8.20435 2.25 9 2.25C9.79565 2.25 10.5587 2.56607 11.1213 3.12868C11.6839 3.69129 12 4.45435 12 5.25V7.5"
                                stroke="currentColor"
                                stroke-linecap="round"
                            ></path>
                            <path
                                d="M3.75 7.5H14.25V14.25C14.25 14.6478 14.092 15.0294 13.8107 15.3107C13.5294 15.592 13.1478 15.75 12.75 15.75H5.25C4.85218 15.75 4.47064 15.592 4.18934 15.3107C3.90804 15.0294 3.75 14.6478 3.75 14.25V7.5Z"
                                stroke="currentColor"
                                stroke-linejoin="round"
                            ></path>
                            <path
                                d="M10.875 11.625H10.8833V11.6333H10.875V11.625Z"
                                stroke="currentColor"
                                stroke-width="1.5"
                                stroke-linejoin="round"
                            ></path>
                        </svg>
                    </button>
                </li>

                <li class="nav-item">
                    <button
                        class="nav-link"
                        :class="{ active: currentTab === 'tab3', 'text-muted': currentTab !== 'tab3' }"
                        @click="currentTab = 'tab3'"
                    >
                        Modèles enregistrés
                    </button>
                </li>
            </ul>
        </div>
        <div class="row mb-3 mt-5">
            <div class="tab-content">
                <component :is="currentTab" :url="url" :url_btn_campaigne_email_create="url_btn_campaigne_email_create">
                </component>
            </div>
        </div>
    </div>
</template>

<script>
// v-select
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import ApiManager from '../Customer/Api/ApiManagerBoCutomer.js'
import { debounce } from 'lodash'
import EmailTemplate from './EmailTemplate.vue'
import CompaingEmailsModelsFree from './CompaingEmailsModelsFree.vue'

export default {
    name: 'MarketingCompaignEmailsIndex',
    props: ['url', 'url_btn_campaigne_email_create'],
    data: () => ({
        currentTab: 'tab1',

        blocks: [{ isOpen: false }, { isOpen: false }, { isOpen: false }, { isOpen: false }, { isOpen: false }],
        model: {
            instance_name: '',
            email_marketing: '',
            selectedOption: 'send-prog',
            sendDate: '',
            sendTime: '',
            selectedFilter: '',
            exclude_emails: [],
        },

        applyedFiltersList: [],

        search: '',
        offset: 1,
        limit: 100,
        total: 0,
        to: 0,

        customers: [],
        loading: false,
    }),
    computed: {
        filtered() {
            return this.customers.filter((row) => row.email.toLocaleLowerCase().includes(this.search.toLocaleLowerCase()))
        },

        hasNextPage() {
            return this.to < this.total
        },
    },
    methods: {
        toggle(index) {
            this.blocks[index].isOpen = !this.blocks[index].isOpen
        },
        enter(el) {
            el.style.height = '0'
            el.style.transition = 'height 0.15s ease'
            requestAnimationFrame(() => {
                el.style.height = el.scrollHeight + 'px'
            })
        },

        leave(el) {
            el.style.height = el.scrollHeight + 'px'
            el.style.transition = 'height 0.15s ease'
            requestAnimationFrame(() => {
                // el.style.height = '0';
            })
        },

        notBeforeToday(date) {
            return date < new Date(new Date().setHours(0, 0, 0, 0))
        },

        notBeforeTodayTwelveOClock(date) {
            return date < new Date(new Date().setHours(12, 0, 0, 0))
        },

        async fetchApplyFilters(params) {
            try {
                const result = await ApiManager.fetchApplyFilters(params)
                this.applyedFiltersList = result?.userCustomFilter ?? []
                this.to = result?.customers.to ?? 0
                this.total = result?.customers.total ?? 0
            } catch (error) {
                this.$toast.error(error.response.data.message)
            }
        },

        async onSearchCustomer(params, loading = null) {
            try {
                const result = await ApiManager.fetchCustomers(params)
                this.customers = result?.data ?? []
            } catch (error) {
                this.$toast.error(error.response.data.message)
            } finally {
                if (loading) {
                    loading(false)
                }
            }
        },

        applyedFiltersChanged() {
            console.log('applyedFiltersChanged', this.model.selectedFilter)
            // this.setFilterData(this.selectedFilter?.display_name ,this.selectedFilter?.filters)
        },

        onSearch(query, loading) {
            if (query.length > 2) {
                loading(true)
                this.debouncedFetchCustomers(loading, query, this)
            } else {
                this.customers = []
            }
        },

        debouncedFetchCustomers: debounce(function (loading, query, vm) {
            this.onSearchCustomer(
                {
                    ajax: true,
                    page: 1,
                    perPage: 15,
                    columns: ['id', 'first_name', 'last_name', 'email'],
                    search: query,
                },
                loading
            )
        }, 300),

        async onOpen() {
            if (!this.hasNextPage) return

            this.$nextTick(() => {
                const dropdownMenu = document.querySelector('.vs__dropdown-menu')
                if (dropdownMenu) {
                    dropdownMenu.addEventListener('scroll', this.onScroll)
                }
            })
        },

        onClose() {
            // this.observer.disconnect()
        },

        remove() {
            this.model.exclude_emails = []
        },

        onScroll(event) {
            const { scrollTop, clientHeight, scrollHeight } = event.target
            if (scrollTop + clientHeight >= scrollHeight - 10 && this.hasNextPage) {
                this.offset += 1
                this.fetchApplyFilters({
                    getCustomersEmails: false,
                    perPage: this.limit,
                    page: this.offset,
                })
            }
        },

        goToEditor(type, filename) {
            const urlParams = new URLSearchParams(window.location.search)
            window.location.href =
                this.url +
                    '?folder=' +
                    type +
                    '&model=' +
                    filename +
                    '&campaigne_email_uuid=' +
                    urlParams.get('campaigne_email_uuid') || ''
        },
    },
    async mounted() {
        this.fetchApplyFilters({
            getCustomersEmails: false,
            perPage: this.limit,
            page: this.offset,
        })

        this.onSearchCustomer({
            ajax: true,
            page: 1,
            perPage: 15,
            columns: ['id', 'first_name', 'last_name', 'email'],
        })
    },
    components: {
        vSelect,
        tab1: CompaingEmailsModelsFree,
        tab3: EmailTemplate,
    },
}
</script>

<style scoped>
.text-muted {
    color: #94a3b8 !important;
}

.collaps {
    background-color: #fff;
    border-radius: 20px;
    border: 1px solid rgba(123, 130, 137, 0.3);
    box-shadow: 0px 4px 40px 0px rgba(0, 0, 0, 0.05);
    padding: 1rem 2rem;
    margin-top: 15px;
}

.collaps-subtitle {
    margin: 0;
    font-weight: 500;
}

.collaps-description {
    margin-bottom: 0 !important;
}

.btn-plr-15 {
    padding: 0 1.5rem !important;
}

.btn-primary {
    width: 200px;
    height: 40px !important;
    border-radius: 24px !important;
}

.btn-primary-inverse {
    height: 40px !important;
    border-radius: 24px !important;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.icon {
    text-align: center;
    font-size: 2rem;
    padding: 0;
}

.icon .fa {
    color: #ccc;
    margin-top: 15px;
}

.text-muted {
    color: #7b8289;
}

.float-right {
    float: right;
}

label {
    font-weight: normal !important;
}

input {
    border-radius: 2px !important;
}

.radio-container {
    color: white;
    cursor: pointer;
    padding: 0.2rem;
    padding-top: 1.5rem;
    border: 1px solid #e2e8f0;
    border-radius: 5px;
}

.selected-container {
    background-color: rgba(98, 194, 246, 0.08);
    border: 1px solid rgba(98, 194, 246, 1);
}

/* Hide the default radio button */
.custom-radio {
    position: absolute;
    opacity: 0;
    cursor: pointer;
}

/* Create a custom radio button */
.custom-radio + label {
    position: relative;
    padding-left: 50px;
    cursor: pointer;
    display: inline-block;
    color: black; /* Default label color */
}

.radio-description {
    padding-left: 50px;
    font-size: 0.8rem;
    cursor: pointer;
}

.custom-radio + label::before {
    content: '';
    position: absolute;
    left: 10px;
    top: 50%;
    width: 20px;
    height: 20px;
    border: 2px solid rgba(98, 194, 246, 1);
    border-radius: 50%;
    background-color: white;
}

/* Custom radio button checked state */
.custom-radio:checked + label::before {
    background-color: rgba(98, 194, 246, 1);
}

.custom-radio:checked + label {
    color: rgba(98, 194, 246, 1); /* Label color when selected */
}

.mx-input {
    border-radius: 5px !important;
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
}

.compaine-img-block {
    margin-top: 1rem;
    width: 100%;
    max-height: 500px;
}

.pagination {
    display: flex;
    margin: 0.25rem 0.25rem 0;
}
.pagination button {
    flex-grow: 1;
}
.pagination button:hover {
    cursor: pointer;
}

#exclude_emails .vs__dropdown-menu {
    height: 350px;
}

.model {
    height: 400px;
    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
}

.wrap {
    margin: 1px;
}

.thumbnail {
    background: #fff;
    height: 330px;
    border: 2px solid #f7f7f7;
    overflow: hidden;
}

.thumbnail img {
    -webkit-transition: transform 7s;
    -moz-transition: transform 7s;
    transition: transform 5s;
    width: 100%;
}

.thumbnail:hover img {
    transform: translateY(-71%);
}

.model-title {
    padding: 0;
    text-align: center;
}
</style>
